module.exports = __webpack_public_path__ + "static/media/DZ.77f11e6d.png";